<ng-template [cdkPortalOutlet]="_calendarHeaderPortal">
</ng-template>

<div class="mat-calendar-content" cdkMonitorSubtreeFocus tabindex="-1">
    @switch(currentView){
        @case('month'){
            <app-sx-month-view 
                [(activeDate)]="activeDate" 
                [selected]="selected" 
                [dateFilter]="dateFilter" 
                [maxDate]="maxDate"
                [minDate]="minDate" 
                (selectedChange)="_dateSelected($event)" 
                (_userSelection)="_userSelected()" 
                class="month-view">
            </app-sx-month-view>
        }
        @case('year'){
            <app-sx-year-view 
                [(activeDate)]="activeDate" 
                [selected]="selected" 
                [dateFilter]="dateFilter" 
                [maxDate]="maxDate"
                [minDate]="minDate" 
                (monthSelected)="_monthSelectedInYearView($event)" 
                (selectedChange)="_goToDateInView($event, 'month')">
            </app-sx-year-view>
        }
        @case('multi-year'){
            <app-sx-multi-year-view 
                [(activeDate)]="activeDate" 
                [selected]="selected" 
                [dateFilter]="dateFilter"
                [maxDate]="maxDate" 
                [minDate]="minDate" 
                (yearSelected)="_yearSelectedInMultiYearView($event)" 
                (selectedChange)="_goToDateInView($event, 'year')">
            </app-sx-multi-year-view>
        }
    }
</div>